export const GFM_INTEREST_EVENTS = {
  shown: 'GFM interest shown',
  ctaClicked: 'GFM interest CTA clicked',
  dismissed: 'GFM interest dismissed'
} as const

// Sent as `dismissMethod`. The modal has no close glyph, so there is no 'x'.
export type GfmDismissMethod = 'not_interested' | 'esc'
